import { useCallback, useState } from 'react';
import { RequestInput } from '../types';
import { APIRequests, MakeRequest } from '../config/api';
import userServices from './user';

export enum APIStatus {
  IDLE = 'idle',
  PENDING = 'pending',
  SUCCESS = 'success',
  ERROR = 'error',
}

export interface APIError {
  code: number;
  message: string;
}

export default function useAPI<T>(request: APIRequests): {
  data: T;
  error?: APIError;
  execute: (input: RequestInput) => Promise<void>;
} {
  let temp: unknown;
  const [data, setData] = useState<T>(temp as T);
  const [error, setError] = useState<APIError>();
  const execute = useCallback(async (input: RequestInput) => {
    const req = MakeRequest(request, input);

    return fetch(req, {
      credentials: 'include',
    })
      .then(async (res) => {
        if (!res.ok) {
          if (res.status === 401) {
            // handling for bad cookie. e.g. we invalidated
            // the cookie on the server
            userServices.deleteAllCookies();
            window.location.href = '/login';
          } else {
            setError({ code: res.status, message: res.statusText });
          }
        }
        return res;
      })
      .then((res) => {
        return res
          .json()
          .then((json) => json)
          .catch(() => {
            return {};
          });
      })
      .then((result) => {
        setData(result);
      })
      .catch((error: Error) => {
        console.error('API Error:', error);
      });
  }, []);

  return { data, execute, error };
}
